<div class="-docpage-skeleton">
  <div class="-docpage-content">
    <div class="-left-pane">
      <div class="-secondary-masthead-skeleton">
        <wp-skeleton height="36px" [width]="'44%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="16px" [width]="'62%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'96%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'88%'" [loading]="true"></wp-skeleton>

        <div class="-secondary-masthead-bottom-row">
          <wp-skeleton height="34px" [width]="'220px'" [loading]="true"></wp-skeleton>
          <wp-skeleton height="34px" [width]="'190px'" [loading]="true"></wp-skeleton>
        </div>
      </div>

      @for (section of [1,2]; track section) {
      <div class="-content-section-skeleton">
        <wp-skeleton height="30px" [width]="'36%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'96%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'92%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="14px" [width]="'78%'" [loading]="true"></wp-skeleton>
      </div>
      }
    </div>

    <div class="-right-pane">
      <div class="sticky-right-pane">
        <wp-skeleton height="24px" [width]="'120px'" [loading]="true"></wp-skeleton>
        @for (i of [1,2,3,4,5,6,7,8,9,10]; track i) {
        <wp-skeleton height="20px" [width]="'100%'" [loading]="true"></wp-skeleton>
        }
      </div>
    </div>
  </div>
</div>
